import millingApi from "../../data/api/millingApi";
import { savedImagePreview, saveImagePreview } from "./imageImportPreview";
import { createImportedTables } from "./createImportedTables";
import { WorkMaterialsTable, WorkFilesTable } from "./WorkAnalyzerTables";
import React, { useState, useEffect, useMemo } from "react";
import {
  Button,
  Table,
  Row,
  Col,
  Modal,
  Form,
  Toast,
  ToastContainer
} from "react-bootstrap";
import workFileApi from "../../data/api/workFileApi";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  getWorkById,
  getCreatedTablesByWork,
  getUser
} from "../../data/getters";
import Loading from "../helpers/Loading";
import { updateWorkApi, setWorkOrderedApi } from "../../data/api/workApi";
import { useRef } from "react";
import objectApi from "../../data/api/objectApi";
import createdItemApi from "../../data/api/createdItemApi";
import createdTablesApi from "../../data/api/createdTablesApi";
import { useGenerateTables } from "../../calculation/generateTables/generateTables";
import {
  buildItemUpdatePayload,
  parsePositions,
  rewriteItemTableIds
} from "../../modules/helpers/tableViewerUtil";
import * as XLSX from "xlsx";
import { useLanguage } from "../helpers/LanguageContext";
import formatPrice from "../helpers/formatPrice";
import CmrPreview from "../helpers/CmrPreview";
import "../../App.css";
import { IonIcon } from "@ionic/react";
import ReactDOM from "react-dom";
import { trashOutline } from "ionicons/icons";
import {
  formatDate,
  formatFileSize as formatFileSizeUtil,
  isImageFile,
  normalizeItemPayload as normalizeItemPayloadUtil,
  parseCmrPreview
} from "./workAnalyzerUtil";
import "../../css/WorkAnalyzer.css";
import {
  matchImportColor,
  matchImportMilling,
  matchImportVariant,
  resolveMdfImageItem
} from "./mdfImportMatching";

function AiColorPicker({ colorId, allColors, onChange, t, wide = false }) {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [dropPos, setDropPos] = useState({
    top: 0,
    left: 0,
    width: 0,
    openUp: false
  });
  const triggerRef = useRef(null);
  const dropRef = useRef(null);

  const colorObj =
    colorId != null
      ? ((allColors || []).find((c) => c.colorId === colorId) ?? null)
      : null;

  const openDropdown = () => {
    if (!triggerRef.current) return;
    setSearch("");
    const rect = triggerRef.current.getBoundingClientRect();
    const spaceBelow = window.innerHeight - rect.bottom;
    const openUp = spaceBelow < 240;
    setDropPos({
      top: openUp
        ? rect.top + window.scrollY - 4
        : rect.bottom + window.scrollY + 2,
      left: rect.left + window.scrollX,
      width: Math.max(rect.width, 180),
      openUp
    });
    setSearch("");
    setOpen(true);
  };

  useEffect(() => {
    if (!open) return;
    const handler = (e) => {
      if (
        !triggerRef.current?.contains(e.target) &&
        !dropRef.current?.contains(e.target)
      )
        setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [open]);

  const filtered = (allColors || []).filter((c) => {
    if (!search) return true;
    const pattern = search
      .split("*")
      .map((s) => s.replace(/[.+?^${}()|[\]\\]/g, "\\$&"))
      .join(".*");
    return new RegExp(pattern, "i").test(t(c.name) ?? "");
  });

  const dropdown = open
    ? ReactDOM.createPortal(
        <div
          ref={dropRef}
          style={{
            position: "absolute",
            top: dropPos.openUp ? undefined : dropPos.top,
            bottom: dropPos.openUp
              ? window.innerHeight - dropPos.top + window.scrollY + 4
              : undefined,
            left: dropPos.left,
            width: dropPos.width,
            zIndex: 9999,
            background: "#fff",
            border: "1px solid #dee2e6",
            borderRadius: 6,
            boxShadow: "0 4px 16px rgba(0,0,0,.15)",
            maxHeight: 220,
            overflowY: "auto"
          }}
          onClick={(e) => e.stopPropagation()}
        >
          {/* Kereső */}
          <div
            style={{
              padding: "6px 8px",
              borderBottom: "1px solid #eee",
              position: "sticky",
              top: 0,
              background: "#fff",
              zIndex: 1
            }}
          >
            <input
              autoFocus
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder={t("searchPlaceholder")}
              style={{
                width: "100%",
                padding: "4px 8px",
                fontSize: 12,
                border: "1px solid #dee2e6",
                borderRadius: 4,
                outline: "none",
                boxSizing: "border-box"
              }}
            />
          </div>

          {/* Nincs szín */}
          <div
            onMouseDown={() => {
              onChange(null);
              setOpen(false);
            }}
            style={{
              display: "flex",
              alignItems: "center",
              gap: 6,
              padding: "5px 8px",
              cursor: "pointer",
              fontSize: 12,
              borderBottom: "1px solid #eee"
            }}
          >
            <div
              style={{
                width: 18,
                height: 18,
                borderRadius: 3,
                border: "1px dashed #ccc"
              }}
            />
            <span style={{ color: "#888" }}>{t("noColor")}</span>
          </div>

          {filtered.map((c) => (
            <div
              key={c.colorId}
              onMouseDown={() => {
                onChange(c.colorId);
                setOpen(false);
              }}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 6,
                padding: "5px 8px",
                cursor: "pointer",
                fontSize: 12,
                background: colorId === c.colorId ? "#f0f5ff" : "transparent"
              }}
            >
              {c.imageDataReduced ? (
                <img
                  src={`data:image/jpeg;base64,${c.imageDataReduced}`}
                  alt={t(c.name)}
                  style={{
                    width: 18,
                    height: 18,
                    objectFit: "cover",
                    borderRadius: 3,
                    border: "1px solid #ccc"
                  }}
                />
              ) : (
                <div
                  style={{
                    width: 18,
                    height: 18,
                    background: c.hex || "#ddd",
                    borderRadius: 3,
                    border: "1px solid #ccc"
                  }}
                />
              )}
              <span
                style={{
                  fontSize: 11,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis"
                }}
              >
                {t(c.name)}
              </span>
            </div>
          ))}
        </div>,
        document.body
      )
    : null;

  return (
    <div
      ref={triggerRef}
      style={{
        position: "relative",
        minWidth: 140,
        width: wide ? "100%" : undefined
      }}
    >
      {/* Trigger chip */}
      <div
        onClick={openDropdown}
        style={{
          display: "flex",
          alignItems: "center",
          gap: 4,
          padding: "2px 6px",
          cursor: "pointer",
          border: "none",
          borderRadius: 0,
          background: "transparent",
          minHeight: 28
        }}
      >
        {colorObj ? (
          <>
            {colorObj.imageDataReduced ? (
              <img
                src={`data:image/jpeg;base64,${colorObj.imageDataReduced}`}
                alt={t(colorObj.name)}
                style={{
                  width: 18,
                  height: 18,
                  objectFit: "cover",
                  borderRadius: 3
                }}
              />
            ) : (
              <div
                style={{
                  width: 18,
                  height: 18,
                  background: colorObj.hex || "#ddd",
                  borderRadius: 3,
                  border: "1px solid #ccc"
                }}
              />
            )}
            <span
              style={{
                fontSize: 11,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: wide ? "calc(100% - 28px)" : 100
              }}
            >
              {t(colorObj.name)}
            </span>
          </>
        ) : (
          <span style={{ fontSize: 11, color: "#888" }}>{t("noColor")}</span>
        )}
        <span style={{ fontSize: 9, color: "#aaa", marginLeft: "auto" }}>
          ▾
        </span>
      </div>

      {dropdown}
    </div>
  );
}

function WorkAnalyzer() {
  const dispatch = useDispatch();
  const { workId } = useParams();
  const generateTables = useGenerateTables();
  const [loading, setLoading] = useState(true);
  const [currentUser, setCurrentUser] = useState(null);
  const selectedWork = useSelector((state) =>
    (state.works || []).find((w) => w.workId === +workId)
  );
  const workFiles = useSelector((state) =>
    (state.workFile?.files || []).filter((f) => f.work?.workId === +workId)
  );
  const selectedClient = selectedWork?.client || null;
  // „Update Work” modal mezői
  const [showModal, setShowModal] = useState(false);
  const [priceInput, setPriceInput] = useState(0);
  const [paidInput, setPaidInput] = useState(0);
  const [labelInput, setLabelInput] = useState(0);
  const [statusInput, setStatusInput] = useState(0);
  const [isDetailsOpen, setIsDetailsOpen] = useState(false);
  const [woodPriceInput, setWoodPriceInput] = useState(0);
  const [isHover, setIsHover] = useState(false);
  const fileInputRef = useRef(null);
  const [importing, setImporting] = useState(false);
  const importingFileIdsRef = useRef(new Set());
  const { t, language } = useLanguage();
  const [previewFile, setPreviewFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [previewText, setPreviewText] = useState(null);

  const [aiPreviewFileName, setAiPreviewFileName] = useState("Import");
  const [aiPreviewImage, setAiPreviewImage] = useState(null);
  const [showAiPreview, setShowAiPreview] = useState(false);
  const [generateAfterImageImport, setGenerateAfterImageImport] =
    useState(false);
  const [savingImageImport, setSavingImageImport] = useState(false);
  const imageImportSavingRef = useRef(false);

  const millings = useSelector((state) => state.millings || []);
  const zoomLevel = useRef(1);
  const imageRef = useRef(null);
  const viewerRef = useRef(null);
  const cellRefs = useRef([]);
  const panRef = useRef({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);
  const dragStart = useRef({ x: 0, y: 0 });
  const [aiPreviewItems, setAiPreviewItems] = useState([]);
  const [savedPreview, setSavedPreview] = useState(null);
  const activeRowRef = useRef(null);
  useEffect(() => {
    const loadCurrentUser = async () => {
      try {
        const user = await dispatch(getUser());
        setCurrentUser(user);
        console.log("currentUser WorkAnalyzer:", user);
      } catch (error) {
        console.error("Error loading current user:", error);
      }
    };

    loadCurrentUser();
  }, [dispatch]);
  const isCompanyRole =
    currentUser?.role === "companyAdmin" || currentUser?.role === "companyUser";
  const handlePreviewFile = async (file) => {
    try {
      const blob = await workFileApi.downloadWorkFileApi(file.fileId);
      const url = window.URL.createObjectURL(blob);

      const ext = file.extension?.toLowerCase();

      if (ext.match(/(png|jpg|jpeg|jfif|gif|webp)/)) {
        setPreviewUrl(url);
        setPreviewFile({ type: "image", name: file.fileName });
      } else if (ext === "pdf") {
        setPreviewUrl(url);
        setPreviewFile({ type: "pdf", name: file.fileName });
      } else if (ext.match(/(xml|cmr)/)) {
        const text = await blob.text();
        const parsed = parseCmrPreview(text);

        setPreviewText(parsed);
        setPreviewFile({ type: "cmr", name: file.fileName });
      } else if (ext.match(/(txt|csv)/)) {
        const text = await blob.text();
        setPreviewText(text);
        setPreviewFile({ type: "text", name: file.fileName });
      } else if (ext.match(/(xlsx|xls)/)) {
        const arrayBuffer = await blob.arrayBuffer();

        const wb = XLSX.read(arrayBuffer, { type: "array" });

        const sheetName = wb.SheetNames[0];
        const ws = wb.Sheets[sheetName];

        const data = XLSX.utils.sheet_to_json(ws, { header: 1 });

        setPreviewText(data);
        setPreviewFile({ type: "excel", name: file.fileName });
      } else {
        setPreviewUrl(url);
        setPreviewFile({ type: "other", name: file.fileName });
      }
    } catch (err) {
      console.error("Preview error:", err);
    }
  };
  const companyAlwaysVisibleFields = (
    <>
      <div style={{ display: "flex", marginBottom: "0.75rem" }}>
        <div style={{ flex: 1, marginRight: "1rem" }}>
          <p className="fs-5 mb-0">
            <strong>{t("status")}:</strong>{" "}
            {selectedWork?.companyStatus
              ? (t(`${selectedWork.companyStatus.toLowerCase()}`) ??
                selectedWork.companyStatus)
              : t("orderNotPlaced")}
          </p>
        </div>
        <div style={{ flex: 1 }}>
          <p className="fs-5 mb-0">
            <strong>{t("orderDate")}:</strong>{" "}
            {selectedWork?.orderDate ? formatDate(selectedWork.orderDate) : "—"}
          </p>
        </div>
      </div>

      <div style={{ display: "flex", marginBottom: "0.75rem" }}>
        <div style={{ flex: 1, marginRight: "1rem" }}>
          <p className="fs-5 mb-0">
            <strong>{t("totalPrice")}:</strong>{" "}
            {formatPrice(selectedWork?.companyPrice || 0)} RON
          </p>
        </div>
        <div style={{ flex: 1 }}>
          <p className="fs-5 mb-0">
            <strong>{t("userPaid")}:</strong>{" "}
            {formatPrice(selectedWork?.userPaid || 0)} RON
          </p>
        </div>
      </div>
    </>
  );
  const companyExpandedFields = (
    <>
      <div style={{ display: "flex", marginBottom: "0.75rem" }}>
        <div style={{ flex: 1, marginRight: "1rem" }}>
          <p className="fs-5 mb-0">
            <strong>{t("labor")}:</strong>{" "}
            {formatPrice(selectedWork?.companyLabel || 0)} RON
          </p>
        </div>
        <div style={{ flex: 1 }}>
          <p className="fs-5 mb-0">
            <strong>{t("userRemaining")}:</strong>{" "}
            {formatPrice(
              (selectedWork?.companyPrice || 0) - (selectedWork?.userPaid || 0)
            )}{" "}
            RON
          </p>
        </div>
      </div>

      <div style={{ display: "flex", marginBottom: "0.75rem" }}>
        <div style={{ flex: 1, marginRight: "1rem" }}>
          <p className="fs-5 mb-0">
            <strong>{t("woodPrice")}:</strong>{" "}
            {formatPrice(selectedWork?.companyWoodPrice || 0)} RON
          </p>
        </div>
        <div style={{ flex: 1 }}>
          <p className="fs-5 mb-0">
            <strong>{t("finishDate")}:</strong>{" "}
            {selectedWork?.companyFinishDate
              ? formatDate(selectedWork.companyFinishDate)
              : "—"}
          </p>
        </div>
      </div>
    </>
  );

  useEffect(() => {
    console.log("🔍 millings store:", millings);
  }, [millings]);

  const findMillingIdByName = (millingHint, colorId = null) => {
    if (!millingHint || !millings?.length) return null;

    const hint = String(millingHint)
      .toLowerCase()
      .trim()
      .replace(/[\/\\]/g, "") // perjel eltávolítása
      .replace(/\s+/g, ""); // szóközök eltávolítása

    if (!hint) return null;

    let candidateMillings = millings;
    if (colorId != null) {
      const color = colors.find((c) => c.colorId === colorId);
      if (color?.millingAssignments) {
        let assignedIds = color.millingAssignments;
        if (typeof assignedIds === "string") {
          assignedIds = assignedIds
            .split(",")
            .map((x) => Number(x.trim()))
            .filter(Boolean);
        }
        if (assignedIds.length > 0) {
          candidateMillings = millings.filter((m) =>
            assignedIds.includes(m.millingId)
          );
        }
      }
    }

    let bestScore = 0;
    let bestMillingId = null;

    for (const m of candidateMillings) {
      const name = (m?.name || m?.code || "")
        .toLowerCase()
        .replace(/[\/\\]/g, "")
        .replace(/\s+/g, "");
      if (!name) continue;

      if (name === hint) return m.millingId; // pontos egyezés → azonnal visszaad

      if (name.includes(hint) || hint.includes(name)) {
        const score = Math.min(name.length, hint.length);
        if (score > bestScore) {
          bestScore = score;
          bestMillingId = m.millingId;
        }
      }
    }

    return bestMillingId;
  };

  const findMillingIdByColorHint = (colorHint) => {
    if (!colorHint || !colors?.length) return null;

    const hint = String(colorHint)
      .toLowerCase()
      .replace(/[^\w\s]/g, " ");
    const tokens = hint.split(/\s+/).filter((t) => t.length > 2);
    if (!tokens.length) return null;

    // legjobban passzoló szín megtalálása
    let bestScore = 0;
    let bestColor = null;

    for (const c of colors) {
      const name = (c?.name || "").toLowerCase();
      if (!name) continue;
      let score = 0;
      for (const token of tokens) {
        if (name.includes(token)) score += token.length;
      }
      if (score > bestScore) {
        bestScore = score;
        bestColor = c;
      }
    }

    if (!bestColor || bestScore < 3) return null;

    // kivonjuk a szín tokenjeit → maradék = milling hint
    const colorTokens = (bestColor.name || "")
      .toLowerCase()
      .replace(/[^\w\s]/g, " ")
      .split(/\s+/)
      .filter((t) => t.length > 0);

    const hintWords = String(colorHint).trim().split(/\s+/);
    const remaining = hintWords
      .filter((word) => !colorTokens.includes(word.toLowerCase()))
      .join(" ")
      .trim();

    if (!remaining) return null;

    // a maradék szövegből keressük a millingId-t
    return findMillingIdByName(remaining, null);
  };

  function AiMillingPicker({
    millingId,
    colorId,
    allColors,
    allMillings,
    onChange,
    t,
    wide = false
  }) {
    const [open, setOpen] = useState(false);
    const triggerRef = useRef(null);
    const dropRef = useRef(null);
    const [search, setSearch] = useState("");
    const [dropPos, setDropPos] = useState({
      top: 0,
      left: 0,
      width: 0,
      openUp: false
    });

    const { availableMillings, hasAssignment } = useMemo(() => {
      // ha nincs colorId kiválasztva → mindent mutass jelzés nélkül
      if (!colorId)
        return { availableMillings: allMillings || [], hasAssignment: false };

      const color = (allColors || []).find((c) => c.colorId === colorId);

      // ha a szín nem található → mindent mutass jelzés nélkül
      if (!color)
        return { availableMillings: allMillings || [], hasAssignment: false };

      // ha van millingAssignments mező, dolgozzuk fel
      if (color.millingAssignments != null) {
        let assignedIds = color.millingAssignments;
        if (typeof assignedIds === "string") {
          assignedIds = assignedIds
            .split(",")
            .map((x) => Number(x.trim()))
            .filter(Boolean);
        }
        // ha van legalább egy assignment → szűrjük
        if (Array.isArray(assignedIds) && assignedIds.length > 0) {
          return {
            availableMillings: (allMillings || []).filter((m) =>
              assignedIds.includes(m.millingId)
            ),
            hasAssignment: true
          };
        }
        // ha üres tömb → szín létezik de nincs assignment → mind nem kompatibilis
        return { availableMillings: [], hasAssignment: true };
      }

      // ha a mező egyáltalán nincs a color objektumon → mind nem kompatibilis
      return { availableMillings: [], hasAssignment: true };
    }, [colorId, allColors, allMillings]);

    const millingObj =
      millingId != null
        ? ((allMillings || []).find(
            (m) => String(m.millingId) === String(millingId)
          ) ?? null)
        : null;

    const openDropdown = () => {
      if (!triggerRef.current) return;
      const rect = triggerRef.current.getBoundingClientRect();
      const spaceBelow = window.innerHeight - rect.bottom;
      const openUp = spaceBelow < 200;
      setDropPos({
        top: openUp
          ? rect.top + window.scrollY - 4
          : rect.bottom + window.scrollY + 2,
        left: rect.left + window.scrollX,
        width: Math.max(rect.width, 160),
        openUp
      });
      setOpen(true);
    };

    useEffect(() => {
      if (!open) return;
      const handler = (e) => {
        if (
          !triggerRef.current?.contains(e.target) &&
          !dropRef.current?.contains(e.target)
        )
          setOpen(false);
      };
      document.addEventListener("mousedown", handler);
      return () => document.removeEventListener("mousedown", handler);
    }, [open]);

    const dropdown = open
      ? ReactDOM.createPortal(
          <div
            ref={dropRef}
            style={{
              position: "absolute",
              top: dropPos.openUp ? undefined : dropPos.top,
              bottom: dropPos.openUp
                ? window.innerHeight - dropPos.top + window.scrollY + 4
                : undefined,
              left: dropPos.left,
              width: dropPos.width,
              zIndex: 9999,
              background: "#fff",
              border: "1px solid #dee2e6",
              borderRadius: 6,
              boxShadow: "0 4px 16px rgba(0,0,0,.15)",
              maxHeight: 200,
              overflowY: "auto"
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div
              style={{
                padding: "6px 8px",
                borderBottom: "1px solid #eee",
                position: "sticky",
                top: 0,
                background: "#fff",
                zIndex: 1
              }}
            >
              <input
                autoFocus
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                placeholder={t("searchPlaceholder")}
                style={{
                  width: "100%",
                  padding: "4px 8px",
                  fontSize: 12,
                  border: "1px solid #dee2e6",
                  borderRadius: 4,
                  outline: "none",
                  boxSizing: "border-box"
                }}
              />
            </div>
            {/* Nincs marás */}
            <div
              onMouseDown={() => {
                onChange(null);
                setOpen(false);
              }}
              style={{
                padding: "5px 8px",
                cursor: "pointer",
                fontSize: 12,
                borderBottom: "1px solid #eee",
                color: "#888"
              }}
            >
              – {t("noMilling1")}
            </div>

            {[...(allMillings || [])]
              .sort((a, b) => {
                if (!hasAssignment) return 0; // ha nincs assignment, ne rendezzen
                const aOk = availableMillings.some(
                  (av) => av.millingId === a.millingId
                );
                const bOk = availableMillings.some(
                  (av) => av.millingId === b.millingId
                );
                if (aOk && !bOk) return -1;
                if (!aOk && bOk) return 1;
                return 0;
              })
              .map((m) => {
                const isCompatible =
                  !hasAssignment ||
                  availableMillings.some((av) => av.millingId === m.millingId);
                return (
                  <div
                    key={m.millingId}
                    onMouseDown={() => {
                      onChange(m.millingId);
                      setOpen(false);
                    }}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      padding: "5px 8px",
                      cursor: "pointer",
                      fontSize: 12,
                      background:
                        millingId === m.millingId ? "#f0f5ff" : "transparent",
                      opacity: isCompatible ? 1 : 0.45
                    }}
                  >
                    <span>{m.name}</span>
                    {hasAssignment &&
                      (isCompatible ? (
                        <span
                          style={{
                            fontSize: 10,
                            color: "#22c55e",
                            fontWeight: 600,
                            marginLeft: 6
                          }}
                        >
                          ✓
                        </span>
                      ) : (
                        <span
                          style={{
                            fontSize: 10,
                            color: "#ef4444",
                            marginLeft: 6
                          }}
                        >
                          ✗
                        </span>
                      ))}
                  </div>
                );
              })}

            {(allMillings || []).length === 0 && (
              <div style={{ padding: "5px 8px", fontSize: 11, color: "#aaa" }}>
                {t("noMilling1Available")}
              </div>
            )}
          </div>,
          document.body
        )
      : null;

    return (
      <div
        ref={triggerRef}
        style={{
          position: "relative",
          minWidth: 120,
          width: wide ? "100%" : undefined
        }}
      >
        <div
          onClick={openDropdown}
          style={{
            display: "flex",
            alignItems: "center",
            gap: 4,
            padding: "2px 6px",
            cursor: "pointer",
            border: "none", // ← bordertelenné
            borderRadius: 0,
            background: "transparent", // ← átlátszó
            minHeight: 28
          }}
        >
          <span
            style={{
              fontSize: 11,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: wide ? "calc(100% - 28px)" : 100,
              color: millingObj ? "#000" : "#bbb"
            }}
          >
            {millingObj ? millingObj.name : t("noMilling1")}
          </span>
          <span style={{ fontSize: 9, color: "#aaa", marginLeft: "auto" }}>
            ▾
          </span>
        </div>
        {dropdown}
      </div>
    );
  }

  // A kép mindig a rendelkezésre álló területre illeszkedik (100% = fit).
  // A nagyítás a kép közepe körül történik, a wheel pedig a kurzor alatti
  // képpontot tartja helyben.
  const clampImagePan = (pan, scale) => {
    const viewer = viewerRef.current;
    const img = imageRef.current;
    if (!viewer || !img?.naturalWidth || !img?.naturalHeight) return pan;
    const w = viewer.clientWidth;
    const h = viewer.clientHeight;
    const fit = Math.min(w / img.naturalWidth, h / img.naturalHeight);
    const maxX = Math.max(0, (img.naturalWidth * fit * scale - w) / 2);
    const maxY = Math.max(0, (img.naturalHeight * fit * scale - h) / 2);
    return {
      x: Math.max(-maxX, Math.min(maxX, pan.x)),
      y: Math.max(-maxY, Math.min(maxY, pan.y))
    };
  };

  const updateTransform = () => {
    if (!imageRef.current) return;
    panRef.current = clampImagePan(panRef.current, zoomLevel.current);
    const { x, y } = panRef.current;
    imageRef.current.style.transform = `translate3d(${x}px, ${y}px, 0) scale(${zoomLevel.current})`;
  };

  const zoomImage = (newZoom, clientX, clientY) => {
    const viewer = viewerRef.current;
    if (!viewer) return;
    const next = Math.max(1, Math.min(6, newZoom));
    const previous = zoomLevel.current;
    const rect = viewer.getBoundingClientRect();
    const x =
      (clientX ?? rect.left + rect.width / 2) - rect.left - rect.width / 2;
    const y =
      (clientY ?? rect.top + rect.height / 2) - rect.top - rect.height / 2;
    const ratio = next / previous;
    panRef.current = {
      x: x - (x - panRef.current.x) * ratio,
      y: y - (y - panRef.current.y) * ratio
    };
    zoomLevel.current = next;
    updateTransform();
  };

  const resetImageView = () => {
    zoomLevel.current = 1;
    panRef.current = { x: 0, y: 0 };
    updateTransform();
  };

  const cancelImagePreview = () => {
    if (savingImageImport || imageImportSavingRef.current) return;
    setShowAiPreview(false);
    resetImageView();
  };

  useEffect(() => {
    if (!showAiPreview) return;
    const handleEscape = (event) => {
      if (event.key === "Escape") {
        event.preventDefault();
        event.stopPropagation();
        cancelImagePreview();
      }
    };
    document.addEventListener("keydown", handleEscape, true);
    return () => document.removeEventListener("keydown", handleEscape, true);
  }, [showAiPreview, savingImageImport]);

  const focusCell = (row, col) => {
    const ref = cellRefs.current?.[row]?.[col];
    if (!ref) return;

    const prevRow = activeRowRef.current;

    if (prevRow !== null) {
      const prevTr = ref
        .closest("table")
        ?.querySelector(`tr[data-row="${prevRow}"]`);
      prevTr?.classList.remove("ai-row-active");
    }

    const tr = ref.closest("tr");
    tr?.classList.add("ai-row-active");

    activeRowRef.current = row;

    ref.focus();

    if (
      ref.tagName === "INPUT" &&
      ref.type !== "number" &&
      typeof ref.setSelectionRange === "function"
    ) {
      const len = ref.value?.length ?? 0;
      ref.setSelectionRange(0, len);
    }
  };
  const handleCellKeyDown = (e, row, col) => {
    const lastCol = 10;
    const isLastRow = row === aiPreviewItems.length - 1;
    const isSelect = e.target.tagName === "SELECT";

    const goDown = () => {
      if (isLastRow) {
        addAiItem();
        setTimeout(() => focusCell(row + 1, col), 0);
      } else {
        focusCell(row + 1, col);
      }
    };

    switch (e.key) {
      case "ArrowRight":
        e.preventDefault();
        focusCell(row, col + 1);
        break;

      case "ArrowLeft":
        e.preventDefault();
        focusCell(row, col - 1);
        break;

      case "ArrowDown":
        // SELECT esetén hagyjuk a dropdown option váltást
        if (isSelect && !e.ctrlKey) return;

        e.preventDefault();
        goDown();
        break;

      case "ArrowUp":
        if (isSelect && !e.ctrlKey) return;

        e.preventDefault();
        focusCell(row - 1, col);
        break;

      case "Enter":
        e.preventDefault();

        if (col === lastCol) {
          if (isLastRow) {
            addAiItem();
            setTimeout(() => focusCell(row + 1, 2), 0);
          } else {
            focusCell(row + 1, 2);
          }
        } else {
          focusCell(row, col + 1);
        }
        break;

      default:
        break;
    }
  };
  const handlePointerDown = (e) => {
    if (e.button !== 0 || zoomLevel.current <= 1) return;
    e.preventDefault();
    e.currentTarget.setPointerCapture(e.pointerId);
    setIsDragging(true);
    dragStart.current = {
      x: e.clientX - panRef.current.x,
      y: e.clientY - panRef.current.y
    };
  };

  const handlePointerMove = (e) => {
    if (!e.currentTarget.hasPointerCapture(e.pointerId)) return;
    panRef.current = {
      x: e.clientX - dragStart.current.x,
      y: e.clientY - dragStart.current.y
    };
    updateTransform();
  };

  const handlePointerUp = (e) => {
    if (e.currentTarget.hasPointerCapture(e.pointerId)) {
      e.currentTarget.releasePointerCapture(e.pointerId);
    }
    setIsDragging(false);
  };

  const handleWheel = (e) => {
    e.preventDefault();
    e.stopPropagation();
    zoomImage(
      zoomLevel.current * Math.exp(-e.deltaY * 0.0015),
      e.clientX,
      e.clientY
    );
  };

  const handleDownloadFile = async (file) => {
    try {
      const blob = await workFileApi.downloadWorkFileApi(file.fileId);

      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = file.fileName;

      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Download error:", err);
      showToast(t("downloadError"), "danger");
    }
  };
  const updateAiItem = (index, field, value) => {
    setAiPreviewItems((prev) => {
      const copy = [...prev];
      const item = {
        ...copy[index],
        size: [...copy[index].size],
        kant: [...(copy[index].kant || emptyKant())]
      };

      if (isAiMdf(item) && field.startsWith("cant_")) return prev;

      if (field === "lun") item.size[0] = Number(value);
      if (field === "lat") item.size[1] = Number(value);
      if (field === "buc") item.qty = Number(value);
      if (field === "obs") item.details = value;
      if (field === "culoare") item.colorHint = value;
      if (field === "painted") item.painted = value;

      if (field === "cant_lung_type") item.kant[0] = value;
      if (field === "cant_lung_count") item.kant[1] = Number(value);

      if (field === "cant_lat_type") item.kant[2] = value;
      if (field === "cant_lat_count") item.kant[3] = Number(value);

      if (field === "rot") item.rotable = value;
      if (field === "cod_frezare") item.codFrezare = value;

      copy[index] = item;
      return copy;
    });
  };

  const removeAiItem = (index) => {
    setAiPreviewItems((prev) => prev.filter((_, i) => i !== index));
  };
  const addAiItem = () => {
    setAiPreviewItems((prev) => {
      const last = prev[prev.length - 1];

      return [
        ...prev,
        {
          size: [0, 0, 18],
          qty: 1,
          details: "",
          kant: ["-", 0, "-", 0],
          rotable: true,
          painted: last?.painted ?? false,
          position: [0, 0, 0],
          rotation: [0, 0, 0],
          colorId: last?.colorId ?? null,
          // örökölt mezők
          colorHint: last?.colorHint || "",
          millingId: last?.millingId ?? null
        }
      ];
    });
  };

  const [uploadingFiles, setUploadingFiles] = useState(false);
  const fileUploadRef = useRef(null);

  const handleUploadFiles = async (files) => {
    if (!files?.length) return;

    setUploadingFiles(true);

    let uploadedCount = 0;
    let importedCount = 0;
    let unresolvedCount = 0;
    const importTiming = { uploadMs: 0, importMs: 0, generationAndSaveMs: 0 };

    try {
      for (const file of files) {
        const uploadStarted = performance.now();
        const uploadedFile = await dispatch(
          workFileApi.uploadWorkFileApi(workId, file)
        );

        importTiming.uploadMs += performance.now() - uploadStarted;
        uploadedCount++;

        const fileName =
          uploadedFile?.fileName ||
          uploadedFile?.data?.fileName ||
          file.name ||
          "";

        const lower = fileName.toLowerCase();

        // Képet nem importálunk automatikusan, az maradjon manuális/AI preview.
        if (isImageFile(lower)) {
          continue;
        }

        try {
          const importStarted = performance.now();
          const importResult = await handleImportExistingFile(
            uploadedFile?.data ?? uploadedFile,
            { triggerGeneration: false, fallbackFileName: fileName }
          );

          importTiming.importMs += performance.now() - importStarted;
          if (importResult?.imported) {
            importedCount++;
            unresolvedCount += Number(importResult.unresolved ?? 0);
          }
        } catch (importErr) {
          console.error("Auto import error:", importErr);
        }
      }

      if (importedCount > 0) {
        const generationStarted = performance.now();
        const generation = await generateAndSaveImportedWork();
        importTiming.generationAndSaveMs =
          performance.now() - generationStarted;
        if (unresolvedCount > 0 || !generation) {
          const reviewMessage = unresolvedCount
            ? `${unresolvedCount} sor ellenőrzést igényel`
            : "nem található automatikusan generálható, felismert színű tétel";
          showToast(
            `${uploadedCount} ${t("filesUploaded")}, ${importedCount} importálva · ${generation ? "a felismert sorok táblái elkészültek" : "nem volt automatikusan generálható sor"} · ${reviewMessage}`,
            "warning"
          );
        } else {
          showToast(
            `${uploadedCount} ${t("filesUploaded")}, ${importedCount} importálva · táblák generálva és elmentve`,
            "success"
          );
        }
      } else {
        showToast(t("filesUploaded"), "success");
      }
    } catch (err) {
      console.error("Upload error:", err);
      showToast(t("uploadError"), "danger");
    } finally {
      console.info(
        "[WorkImport] Upload/import timing (ms)",
        Object.fromEntries(
          Object.entries(importTiming).map(([stage, elapsed]) => [
            stage,
            Math.round(elapsed)
          ])
        )
      );
      setUploadingFiles(false);
    }
  };

  const handleDrop = async (e) => {
    e.preventDefault();
    const files = Array.from(e.dataTransfer.files || []);
    await handleUploadFiles(files);
  };

  const handleFileInputChange = async (e) => {
    const files = Array.from(e.target.files || []);
    await handleUploadFiles(files);
    e.target.value = "";
  };

  // Rendelés megerősítő modal
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  // NEW: export állapot
  const [exporting, setExporting] = useState(false);
  const handleExportExcel = async () => {
    try {
      setExporting(true);

      // 1) Meglévő PAL/PFL/GIZIR export
      const fname =
        await createdItemApi.exportCreatedItemsExcelForWorkApi(workId);
      showToast(t("exportSuccess").replace("{file}", fname), "success");

      // 2) Ha van MDF item, azokat is exportáljuk
      const hasMdf = createdItems.some((ci) => {
        const colorId = ci.colorId ?? ci.color?.colorId;
        const colorObj = colors.find((c) => c.colorId === colorId);
        return colorObj?.materialType === "MDF";
      });

      if (hasMdf) {
        const combos = await createdItemApi.getMdfCombinationsApi(workId);
        if (combos?.length) {
          for (const combo of combos) {
            await createdItemApi.exportMdfExcelApi(
              workId,
              combo.colorName,
              combo.millingName
            );
          }
        }
      }
    } catch (err) {
      console.error("Excel export hiba:", err);
      const msg =
        err?.response?.status === 403
          ? t("exportNoPermission")
          : t("exportError");
      showToast(msg, "danger");
    } finally {
      setExporting(false);
    }
  };

  const createdItems = useSelector((state) => state.createdItems).filter(
    (item) => item.work.workId === +workId
  );
  const allTablesRaw = useSelector((state) => state.createdTables || []);
  const colors = useSelector((state) => state.colors || []);

  // A ténylegesen kiválasztott szín típusa az elsődleges forrás.
  // Ha még nincs szín, az importált anyagtípus a tartalék.
  const isAiMdf = (item) => {
    const color = colors.find(
      (c) => String(c.colorId) === String(item.colorId)
    );
    return color
      ? String(color.materialType).toUpperCase() === "MDF"
      : String(item.importMaterial || "").toUpperCase() === "MDF";
  };
  const emptyKant = () => ["-", 0, "-", 0];
  const normalizeAiMdfKant = (items) =>
    items.map((item) =>
      isAiMdf(item)
        ? { ...item, importMaterial: "MDF", kant: emptyKant() }
        : item
    );
  // Vegyes PAL/MDF lista esetén a kant oszlopok a PAL sorok miatt megmaradnak.
  const hideAiKantColumns =
    aiPreviewItems.length > 0 && aiPreviewItems.every(isAiMdf);
  useEffect(() => {
    console.log("🔍 allTablesRaw:", allTablesRaw);
  }, [allTablesRaw]);
  // 1) csak az adott munkához tartozók
  const tablesForThisWork = useMemo(
    () => allTablesRaw.filter((t) => t.work.workId == workId),
    [allTablesRaw, workId]
  );
  const [toast, setToast] = useState({
    show: false,
    message: "",
    variant: "success"
  });
  const showToast = (message, variant = "success") =>
    setToast({ show: true, message, variant });

  const normalizeItemPayload = normalizeItemPayloadUtil;
  const formatFileSize = formatFileSizeUtil;
  // colors már be van húzva a store-ból (useSelector)
  const findColorIdByNameFragment = (nameFrag) => {
    if (!nameFrag || !colors?.length) return null;

    const tokens = String(nameFrag)
      .toLowerCase()
      .replace(/[^\w\s]/g, " ")
      .split(/\s+/)
      .filter((t) => t.length > 2); // túl rövid szavakat kiszűrjük

    if (!tokens.length) return null;

    let bestScore = 0;
    let bestColorId = null;

    for (const c of colors) {
      const name = (c?.name || "").toLowerCase();
      if (!name) continue;

      let score = 0;

      for (const token of tokens) {
        if (name.includes(token)) {
          score += token.length; // hosszabb szó nagyobb súly
        }
      }

      if (score > bestScore) {
        bestScore = score;
        bestColorId = c.colorId;
      }
    }

    // minimum egyezési threshold
    if (bestScore < 3) return null;

    return bestColorId;
  };
  const createImportObjectAndItems = async ({
    items,
    colorHint,
    fileName = "",
    onSaved,
    importMillings = millings
  }) => {
    if (!selectedWork) throw new Error("Nincs kiválasztott munka.");

    // 1) Létrehozunk egy "Import" objectet
    const createBody = {
      name: `Import - ${fileName}`,
      work: { workId: selectedWork.workId },
      client: selectedClient ? { clientId: selectedClient.clientId } : null,
      usedScript: null,
      usedColors: "[]",
      setting: "{}",
      size: "[0,0,0]",
      position: "[0,0,0]",
      rotation: "[0,0,0]"
    };

    const objResp = await dispatch(objectApi.createObjectApi(createBody));
    const newObjectId = objResp?.objectId ?? objResp?.data?.objectId;
    if (!newObjectId)
      throw new Error("Object létrehozás nem adott objectId-t.");

    // 2) Payloadok összeállítása – KÖTELEZŐ position/rotation + normalizálás
    const itemsToSave = items.map((it) => {
      const mdf = isAiMdf(it);
      const itemFileName = it.importFileName || fileName;
      const fileHint = String(itemFileName || "").replace(/\.[^.]+$/, "");
      const itemColorHint = it.colorHint || colorHint;
      const combinedHint = `${itemColorHint || ""} ${fileHint}`.trim();
      const colorId =
        it.colorId != null
          ? it.colorId
          : mdf
            ? (matchImportColor(itemColorHint, colors)?.colorId ??
              matchImportColor(fileHint, colors)?.colorId ??
              matchImportColor(combinedHint, colors)?.colorId ??
              null)
            : (findColorIdByNameFragment(itemColorHint) ??
              findColorIdByNameFragment(fileHint) ??
              findColorIdByNameFragment(combinedHint) ??
              null);

      let millingId = null;
      if (it.millingId != null) {
        millingId = it.millingId;
      } else if (it.milling?.millingId != null) {
        millingId = it.milling.millingId;
      } else if (mdf) {
        const itemColor = colors.find(
          (c) => String(c.colorId) === String(colorId)
        );
        millingId =
          [
            it.codFrezare,
            typeof it.milling === "string" ? it.milling : "",
            itemColorHint,
            fileHint,
            combinedHint
          ]
            .map(
              (hint) =>
                matchImportMilling(hint, importMillings, itemColor)?.millingId
            )
            .find((id) => id != null) ?? null;
      } else if (it.codFrezare) {
        millingId =
          findMillingIdByName(it.codFrezare, colorId) ??
          findMillingIdByName(fileHint, colorId) ??
          findMillingIdByName(combinedHint, colorId);
        console.log("🔍 codFrezare keresés:", {
          codFrezare: it.codFrezare,
          colorId,
          millingId,
          allMillings: millings.map((m) => ({
            id: m.millingId,
            name: m.name,
            code: m.code
          }))
        });
      } else if (typeof it.milling === "string" && it.milling) {
        millingId =
          findMillingIdByName(it.milling, colorId) ??
          findMillingIdByName(fileHint, colorId) ??
          findMillingIdByName(combinedHint, colorId);
      } else {
        millingId =
          findMillingIdByColorHint(combinedHint) ??
          findMillingIdByColorHint(itemColorHint) ??
          findMillingIdByColorHint(fileHint) ??
          null;
      }

      if (mdf && it.codFrezare && millingId == null) {
        console.warn("MDF milling unresolved", {
          hint: it.codFrezare,
          colorId,
          assignments: colors.find((c) => String(c.colorId) === String(colorId))
            ?.millingAssignments,
          candidates: importMillings.map((m) => ({
            id: m.millingId,
            name: m.name,
            materialType: m.materialType,
            active: m.active
          }))
        });
      }
      const selectedMilling = importMillings.find(
        (m) => String(m.millingId) === String(millingId)
      );
      const variant = mdf
        ? matchImportVariant(it.details, selectedMilling)
        : null;
      const base = {
        name: `Import - ${fileName}`,
        details: it.details || "",
        material: "",
        kant: "",
        qty: it.qty ?? 1,
        rotable: it.rotable ?? true,
        painted: it.painted ?? false,
        size: it.size ?? [0, 0, 0],
        position: it.position ?? [0, 0, 0],
        rotation: it.rotation ?? [0, 0, 0],
        object: { objectId: newObjectId },
        work: { workId: selectedWork.workId },
        kant: mdf ? emptyKant() : (it.kant ?? emptyKant()),
        ...(millingId != null
          ? {
              milling: { millingId },
              millingVariantId:
                variant?.variantId || it.millingVariantId || null
            }
          : {})
      };

      const payload = normalizeItemPayload(base);
      if (colorId != null) payload.color = { colorId };

      return payload;
    });

    // 3) Több tétel mentése egyszerre
    const savedItems = await dispatch(
      createdItemApi.createMultipleCreatedItemsApi(itemsToSave, {
        preprocess: true
      })
    );
    onSaved?.(savedItems, newObjectId);

    return itemsToSave.filter((payload, index) => {
      const itemFileName = items[index].importFileName || fileName;
      const hasMillingHint =
        items[index].codFrezare ||
        items[index].milling ||
        /\bFS\s*\d+/i.test(itemFileName || "");
      return (
        (items[index].importMaterial === "MDF" ||
          items[index].importMaterial === "PAL") &&
        ((!payload.color &&
          (items[index].colorHint || colorHint || itemFileName)) ||
          (!payload.milling && hasMillingHint))
      );
    }).length;
  };

  /**
   * Kézi fájlimport után ugyanazzal a frontend generátorral készítjük el
   * a táblákat, mint a TableViewerben, majd az eredményt azonnal mentjük.
   *
   * FONTOS:
   * - az itemeket közvetlenül a backendről olvassuk vissza, így nem függünk
   *   attól, hogy a Redux store már frissült-e;
   * - a meglévő táblákat átadjuk a generátornak, így az optimalizáló ugyanazt
   *   a kontextust kapja, mint a normál frontend generálás;
   * - negatív ideiglenes table ID -> valódi backend ID átírás megtörténik;
   * - az item tablePosition mentése requiresRegenerate:false opcióval történik,
   *   ezért nem indul el újra backend generálás.
   */
  const generateAndSaveImportedWork = async () => {
    const numericWorkId = Number(workId);

    const [freshItemsRaw, existingTablesRaw] = await Promise.all([
      createdItemApi.getAllCreatedItemsForWorkApi(numericWorkId),
      createdTablesApi.getAllCreatedTablesForWorkApi(numericWorkId)
    ]);

    const freshItems = (freshItemsRaw || []).map((item) => ({
      ...item,
      color:
        item.color?.colorId != null
          ? { ...item.color, colorId: item.color.colorId }
          : null
    }));
    const resolvedItems = freshItems.filter(
      (item) => item.color?.colorId != null
    );

    const existingTables = (existingTablesRaw || []).map((table) => ({
      ...table,
      id: table.id ?? table.tableId
    }));

    if (resolvedItems.length === 0) return null;

    const generated = await Promise.resolve(
      generateTables(
        numericWorkId,
        {
          scope: "work",
          mode: "full",
          colorIds: [],
          tableIds: [],
          TRIM: 10,
          direction: "both",
          allowHalfTable: true
        },
        resolvedItems,
        existingTables
      )
    );

    if (
      !generated ||
      !Array.isArray(generated.createdItems) ||
      !Array.isArray(generated.createdTables) ||
      !generated.work
    ) {
      throw new Error("INVALID_GENERATOR_RESPONSE");
    }

    const generatedTables = generated.createdTables;

    /*
     * 1. Meglévő, pozitív ID-jú táblák frissítése.
     */
    const existingGeneratedTables = generatedTables
      .filter((table) => Number(table.id) > 0)
      .map((table) => ({
        ...table,
        id: Number(table.id),
        frontend: false
      }));

    if (existingGeneratedTables.length > 0) {
      await dispatch(
        createdTablesApi.updateMultipleCreatedTablesApi(existingGeneratedTables)
      );
    }

    /*
     * 2. Új, negatív temp ID-jú táblák létrehozása.
     */
    const idMap = await createImportedTables(generatedTables, (table) =>
      dispatch(createdTablesApi.createCreatedTablesApi(table))
    );

    /*
     * 3. A generált itemekben a temp table ID-k átírása.
     */
    const rewrittenItems = rewriteItemTableIds(
      generated.createdItems,
      idMap,
      parsePositions
    );

    /*
     * 4. Itemek mentése.
     *
     * Az itemek legyenek az utolsó layout-írások, hogy a tablePosition
     * biztosan a frissen létrehozott valódi table ID-ket tartalmazza.
     */
    const itemPayloads = rewrittenItems
      .filter((item) => Number(item.itemId) > 0)
      .map((item) => ({
        itemId: Number(item.itemId),
        ...buildItemUpdatePayload(item),
        tablePosition: String(item.tablePosition ?? "")
      }));

    if (itemPayloads.length > 0) {
      await dispatch(
        createdItemApi.updateMultipleCreatedItemsApi(itemPayloads, {
          requiresRegenerate: false
        })
      );
    }

    /*
     * 5. Work összesítések/árak mentése.
     *
     * Az MDF woodPrice számítást a frontend updateWork() végzi:
     * MDF => tableUsage * price.
     */
    const generatedWork = generated.work;

    await dispatch(
      updateWorkApi(numericWorkId, {
        cutLength: generatedWork.cutLength,
        kantLength: generatedWork.kantLength,
        partCount: generatedWork.partCount,
        measureCount: generatedWork.measureCount,
        tableUsage: generatedWork.tableUsage,
        usedTables: generatedWork.usedTables,
        woodPrice: generatedWork.woodPrice,
        clientPrice: generatedWork.clientPrice
      })
    );

    /*
     * 6. Store frissítése a backendből.
     */
    await Promise.all([
      dispatch(getWorkById(numericWorkId)),
      dispatch(getCreatedTablesByWork(numericWorkId))
    ]);

    return {
      ...generated,
      createdItems: rewrittenItems,
      createdTables: generatedTables.map((table) => {
        const realId = idMap[String(table.id)];

        return realId != null
          ? {
              ...table,
              id: realId,
              frontend: false
            }
          : {
              ...table,
              frontend: false
            };
      })
    };
  };

  const handleManualImport = async (file) => {
    setSavedPreview(null);
    try {
      const blob = await workFileApi.downloadWorkFileApi(file.fileId);
      const url = window.URL.createObjectURL(blob);

      setAiPreviewImage(url);
      setAiPreviewFileName(file.fileName);
      // üres kezdő elem
      setAiPreviewItems([
        {
          size: [0, 0, 18],
          qty: 1,
          details: "",
          kant: ["-", 0, "-", 0],
          rotable: true,
          painted: false,
          position: [0, 0, 0],
          rotation: [0, 0, 0],
          colorHint: "",
          codFrezare: ""
        }
      ]);

      setShowAiPreview(true);
    } catch (err) {
      console.error("Manual import error:", err);
      showToast(t("imageOpenError"), "danger");
    }
  };
  const handleImportExistingFile = async (
    file,
    { triggerGeneration = true, fallbackFileName = "" } = {}
  ) => {
    if (importingFileIdsRef.current.has(file.fileId)) return;
    importingFileIdsRef.current.add(file.fileId);
    try {
      setImporting(true);

      const fileName = file.fileName || fallbackFileName || "";
      const lower = fileName.toLowerCase();

      // ==============================
      // IMAGE → AI PARSE
      // ==============================
      if (isImageFile(lower)) {
        const blob = await workFileApi.downloadWorkFileApi(file.fileId);
        const parsed = await dispatch(
          workFileApi.parseWorkFileOcrApi(file.fileId)
        );
        console.log("AI PARSE RESULT:", parsed);

        if (!parsed || !parsed.pozitii?.length) {
          console.warn("AI nem talált értelmezhető adatot.");
          showToast(t("imageParseError"), "warning");
          return;
        }

        // cant_pe_lungime / cant_pe_latime -> típus és darabszám kinyerése
        const getCantType = (cant) => {
          if (!cant) return "-";
          for (const [type, val] of Object.entries(cant)) {
            if (Number(val) > 0) return type;
          }
          return "-";
        };

        const getCantCount = (cant) => {
          if (!cant) return 0;
          for (const val of Object.values(cant)) {
            if (Number(val) > 0) return Number(val);
          }
          return 0;
        };

        // Use the request result, not the render's potentially stale Redux closure.
        const importMillings =
          parsed.material_type === "MDF"
            ? await millingApi.getAllMillingsApi()
            : millings;
        if (!Array.isArray(importMillings))
          throw new Error("Invalid milling catalog response");
        const items = parsed.pozitii
          .map((p) => ({
            size: [Number(p.lungime_mm), Number(p.latime_mm), 18],
            qty: Number(p.buc) || 1,
            details: p.observatii || "",
            kant:
              parsed.material_type === "MDF"
                ? emptyKant()
                : [
                    getCantType(p.cant_pe_lungime),
                    getCantCount(p.cant_pe_lungime),
                    getCantType(p.cant_pe_latime),
                    getCantCount(p.cant_pe_latime)
                  ],
            rotable: p.rot ?? true,
            position: [0, 0, 0],
            rotation: [0, 0, 0],
            importMaterial: parsed.material_type === "MDF" ? "MDF" : "PAL",
            painted: p.painted === true,
            millingId:
              parsed.material_type === "MDF"
                ? null
                : (findMillingIdByName(
                    p.cod_frezare || p.cod_culoare,
                    p.color_id
                  ) ?? null),
            colorId: p.color_id ?? null, // ← backend adja vissza
            colorHint: p.cod_culoare || "", // megmarad fallbacknek
            codFrezare: p.cod_frezare || "",
            milling: p.cod_frezare || ""
          }))
          .map((item) => resolveMdfImageItem(item, colors, importMillings));
        const unresolved = await createImportObjectAndItems({
          items,
          colorHint: "",
          fileName,
          importMillings,
          onSaved: (savedItems, objectId) => {
            const material = parsed.material_type === "MDF" ? "MDF" : "PAL";
            setSavedPreview({
              objectId,
              ids: savedItems.map((item) => item.itemId),
              material
            });
            setAiPreviewItems(
              normalizeAiMdfKant(savedImagePreview(savedItems, material))
            );
            setAiPreviewFileName(fileName);
            setAiPreviewImage(URL.createObjectURL(blob));
            setShowAiPreview(true);
          }
        });
        showToast(
          unresolved
            ? `${items.length} sor automatikusan elmentve. ${unresolved} sornál ellenőrizd a színt vagy a marást az elemek között.`
            : `${items.length} sor automatikusan elmentve, az előfeldolgozással együtt.`,
          unresolved ? "warning" : "success"
        );
        return { imported: true, unresolved };
      }

      const result = await dispatch(workFileApi.importWorkFileApi(file.fileId));
      const itemCount = Number(result?.itemCount ?? 0);
      const unresolved = Number(result?.unresolvedCount ?? 0);

      if (!result?.imported || itemCount === 0) {
        showToast(t("importNoItems"), "warning");
        return { imported: false, unresolved: 0 };
      }

      const generation = triggerGeneration
        ? await generateAndSaveImportedWork()
        : null;

      showToast(
        `${itemCount} ${t("itemsImported")}${
          unresolved
            ? ` · ${generation ? "a felismert sorok táblái elkészültek; " : ""}${unresolved} sornál a szín vagy marás nem azonosítható egyértelműen; ellenőrizd az importált elemeket.`
            : triggerGeneration
              ? generation
                ? " · Táblák generálva és elmentve."
                : " · Nem volt automatikusan generálható sor."
              : ""
        }`,
        unresolved ? "warning" : "success"
      );

      return {
        imported: true,
        unresolved
      };
    } catch (err) {
      console.error(err);
      showToast(t("importError"), "danger");
      return {
        imported: false,
        unresolved: 0,
        error: err
      };
    } finally {
      importingFileIdsRef.current.delete(file.fileId);
      setImporting(importingFileIdsRef.current.size > 0);
    }
  };
  const handleDeleteFile = async (fileId) => {
    if (!window.confirm(t("confirmDeleteFile"))) return;
    try {
      await dispatch(workFileApi.deleteWorkFileApi(fileId));

      showToast(t("fileDeleted"), "success");
    } catch (err) {
      console.error(err);
      showToast(t("deleteError"), "danger");
    }
  };
  const handleImportFile = async (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    try {
      await handleUploadFiles(files);
    } catch (err) {
      console.error("Import error:", err);
      showToast(t("importError"), "danger");
    } finally {
      e.target.value = "";
    }
  };

  useEffect(() => {
    console.log("🔍 tablesForThisWork:", tablesForThisWork);
  }, [tablesForThisWork]);
  // 2) minden táblához „kigyűjtjük” a teljes szín‐objektumot a colors listából
  const createdTables = useMemo(
    () =>
      tablesForThisWork.map((t) => {
        const fullColor = colors.find((c) => c.colorId === t.color.colorId) || {
          colorId: t.color.colorId,
          name: "Ismeretlen",
          hex: "#ccc"
        };
        return { ...t, color: fullColor };
      }),
    [tablesForThisWork, colors]
  );
  const fallbackTotal = useMemo(
    () => createdTables.reduce((sum, t) => sum + t.price, 0),
    [createdTables]
  );
  const totalPrice =
    (selectedWork?.clientPrice ?? 0) > 0
      ? selectedWork.clientPrice
      : fallbackTotal + (selectedWork?.label ?? 0);

  // totalWoodPrice: ha van woodPrice (>0), azt mutatjuk, különben csak a createdTables összege
  const totalWoodPrice =
    (selectedWork?.woodPrice ?? 0) > 0 ? selectedWork.woodPrice : fallbackTotal;
  // Betöltjük a work és kliens adatokat

  useEffect(() => {
    const loadAllWorkData = async () => {
      setLoading(true);
      try {
        const work = await dispatch(getWorkById(workId));
        //  setSelectedWork(work);
        //setSelectedClient(work.client);
        setStatusInput(work.status);

        // Várjuk meg a táblák és itemek betöltését is
        await Promise.all([
          dispatch(getCreatedTablesByWork(workId))
          //   dispatch(getAllCreatedItems()) // vagy fetchCreatedItemsForWork(workId), ha az a jó
        ]);
      } catch (error) {
        console.error("Error loading data:", error);
      } finally {
        setLoading(false);
      }
    };

    loadAllWorkData();
  }, [dispatch, workId]);

  useEffect(() => {
    const loadTables = async () => {
      try {
        await dispatch(getCreatedTablesByWork(workId));
      } catch (error) {
        console.error(
          "Error fetching created tables:",
          error,
          error.response?.status,
          error.response?.data
        );
      }
    };
    loadTables();
  }, [dispatch, workId]);
  const colorOrderMap = useMemo(() => {
    const map = new Map();
    colors.forEach((c, index) => {
      map.set(c.colorId, index);
    });
    return map;
  }, [colors]);
  const groupedTables = useMemo(() => {
    return createdTables.reduce((acc, table) => {
      const colorId = table.color?.colorId ?? "no-color";
      const millingId = table.milling?.millingId ?? "no-milling";

      const millingObj = millings.find(
        (m) => m.millingId === table.milling?.millingId
      );

      const millingName = millingObj?.name || t("noMilling1");

      const groupKey = `${colorId}__${millingId}`;

      const colorObj = colors.find((c) => c.colorId === table.color?.colorId);
      const isMdf = colorObj?.materialType === "MDF";

      if (!acc[groupKey]) {
        acc[groupKey] = {
          colorId, // 👈 FONTOS a sorthoz
          color: t(table.color.name),
          millingId,
          milling: millingName,
          quantity: 0,
          totalPrice: 0,
          pricePerQty: table.color.price ?? 0,
          isMdf
        };
      }

      const splitDim = table.color.splitDimension;
      const isSplit =
        splitDim &&
        table.size &&
        table.size.replace(/\s+/g, "") === splitDim.replace(/\s+/g, "");

      if (isMdf) {
        acc[groupKey].quantity += table.tableUsage ?? 0;
      } else {
        acc[groupKey].quantity += isSplit ? 0.5 : 1;
      }
      if (isMdf) {
        acc[groupKey].totalPrice += table.price * (table.tableUsage ?? 0);
      } else {
        acc[groupKey].totalPrice += table.price;
      }
      return acc;
    }, {});
  }, [createdTables, colors, millings, t]);
  const sortedGroupedTables = useMemo(() => {
    return Object.values(groupedTables).sort((a, b) => {
      const aOrder = colorOrderMap.get(a.colorId) ?? 999;
      const bOrder = colorOrderMap.get(b.colorId) ?? 999;

      if (aOrder !== bOrder) return aOrder - bOrder;

      // ha azonos szín → milling szerint
      return a.milling.localeCompare(b.milling);
    });
  }, [groupedTables, colorOrderMap]);
  // „Update Work” modal megnyitása: előtöltjük a mezőket
  const handleShowModal = () => {
    if (!selectedWork) return;
    // initial price: clientPrice vagy fallback+label
    const cp = selectedWork.clientPrice ?? 0;
    const fallback = fallbackTotal + (selectedWork.label ?? 0);
    setPriceInput(cp > 0 ? cp : fallback);
    setPaidInput(selectedWork.clientPaid || 0);
    setLabelInput(selectedWork.label || 0);
    setStatusInput(selectedWork.status);
    // initial wood price
    const wp = selectedWork.woodPrice ?? 0;
    setWoodPriceInput(wp > 0 ? wp : fallbackTotal);
    setShowModal(true);
  };
  const handleCloseModal = () => setShowModal(false);

  // „Update Work” mentése, figyeljük a „Completed” vagy „Cancelled” állapotot
  const handleSave = async () => {
    if (!selectedWork) {
      handleCloseModal();
      return;
    }
    const today = new Date().toISOString();
    const payload = {
      clientPrice: priceInput,
      clientPaid: paidInput,
      label: labelInput,
      woodPrice: woodPriceInput,
      status: statusInput
    };
    if (statusInput === "Completed") {
      payload.finishDate = today;
      payload.status = "completed";
    }
    if (statusInput === "Cancelled") {
      payload.cancelDate = today;
      payload.status = "Cancelled";
    }
    await dispatch(updateWorkApi(workId, payload));
    handleCloseModal();
  };

  // „Order Now” gomb: először ellenőrizzük, hogy van‐e legalább egy createdTable
  const handleOrderSelectedWork = () => {
    if (!selectedWork) return;
    if (!Array.isArray(createdTables) || createdTables.length === 0) {
      alert(t("orderNoTables"));
      return;
    }

    if (!Array.isArray(createdItems) || createdItems.length === 0) {
      alert(t("orderNoItems"));
      return;
    }

    const unassigned = createdItems.filter(
      (ci) =>
        (ci.tablePosition == null || ci.tablePosition === "") &&
        ci.color.colorId == null
    );
    if (unassigned.length > 0) {
      alert(t("orderUnassignedItems", { count: unassigned.length }));
      return;
    }

    setShowConfirmModal(true);
  };

  const handleConfirmOrder = async () => {
    if (!selectedWork) {
      setShowConfirmModal(false);
      return;
    }
    try {
      // szerver oldalon: isOrdered=true, orderDate beállítás, üres táblák törlése
      await dispatch(setWorkOrderedApi(workId, true, { refreshRelated: true }));
    } catch (e) {
      alert(t("orderError"));
    } finally {
      setShowConfirmModal(false);
    }
  };
  const handleCancelOrder = () => {
    setShowConfirmModal(false);
  };

  const statusLabel = (status) => t(status?.toLowerCase() ?? status);

  // Mindig látható „összesítő” mezők
  const alwaysVisibleFields = (
    <>
      {/* 1. Sor: Work Status / Order Status */}
      <div style={{ display: "flex", marginBottom: "0.75rem" }}>
        <div style={{ flex: 1, marginRight: "1rem" }}>
          <p className="fs-5 mb-0">
            <strong>{t("status")}:</strong> {statusLabel(selectedWork?.status)}
          </p>
        </div>
        <div style={{ flex: 1 }}>
          <p className="fs-5 mb-0">
            <strong>{t("orderStatus")}:</strong>{" "}
            {selectedWork?.companyStatus
              ? (t(`${selectedWork?.companyStatus}`) ??
                selectedWork?.companyStatus)
              : t("orderNotPlaced")}
          </p>
        </div>
      </div>

      {/* 2. Sor: Total Price / Order Price */}
      <div style={{ display: "flex", marginBottom: "0.75rem" }}>
        <div style={{ flex: 1, marginRight: "1rem" }}>
          <p className="fs-5 mb-0">
            <strong>{t("totalPrice")}:</strong> {formatPrice(totalPrice)} RON
          </p>
        </div>
        <div style={{ flex: 1 }}>
          <p className="fs-5 mb-0">
            <strong>{t("orderTotal")}:</strong>{" "}
            {formatPrice(selectedWork?.companyPrice || 0)} RON
          </p>
        </div>
      </div>
    </>
  );

  // Részletek (lenyíló) mezők
  const expandedFields = (
    <>
      {/* Client Paid / User Paid */}
      <div style={{ display: "flex", marginBottom: "0.75rem" }}>
        <div style={{ flex: 1, marginRight: "1rem" }}>
          <p className="fs-5 mb-0">
            <strong>{t("clientPaid")}:</strong>{" "}
            {formatPrice(selectedWork?.clientPaid || 0)} RON
          </p>
        </div>
        <div style={{ flex: 1 }}>
          <p className="fs-5 mb-0">
            <strong>{t("userPaid")}:</strong>{" "}
            {formatPrice(selectedWork?.userPaid || 0)} RON
          </p>
        </div>
      </div>

      {/* Client Has to Pay / User Has to Pay */}
      <div style={{ display: "flex", marginBottom: "0.75rem" }}>
        <div style={{ flex: 1, marginRight: "1rem" }}>
          <p className="fs-5 mb-0">
            <strong>{t("clientRemaining")}:</strong>{" "}
            {formatPrice(
              (+selectedWork?.clientPrice || 0) -
                (+selectedWork?.clientPaid || 0)
            )}{" "}
            RON
          </p>
        </div>
        <div style={{ flex: 1 }}>
          <p className="fs-5 mb-0">
            <strong>{t("userRemaining")}:</strong>{" "}
            {formatPrice(
              selectedWork?.companyPrice - selectedWork?.userPaid || 0
            )}{" "}
            RON
          </p>
        </div>
      </div>

      {/* Wood Price / Company Wood Price */}
      <div style={{ display: "flex", marginBottom: "0.75rem" }}>
        <div style={{ flex: 1, marginRight: "1rem" }}>
          <p className="fs-5 mb-0">
            <strong>{t("woodPrice")}:</strong>{" "}
            {formatPrice(
              (selectedWork?.woodPrice ?? 0) > 0
                ? selectedWork.woodPrice
                : totalWoodPrice
            )}{" "}
            RON
          </p>
        </div>
        <div style={{ flex: 1 }}>
          <p className="fs-5 mb-0">
            <strong>{t("companyWoodPrice")}:</strong>{" "}
            {formatPrice(selectedWork?.companyWoodPrice)} RON
          </p>
        </div>
      </div>

      {/* Label / Company Label */}
      <div style={{ display: "flex", marginBottom: "0.75rem" }}>
        <div style={{ flex: 1, marginRight: "1rem" }}>
          <p className="fs-5 mb-0">
            <strong>{t("laborUser")}:</strong>{" "}
            {formatPrice(selectedWork?.label)} RON
          </p>
        </div>
        <div style={{ flex: 1 }}>
          <p className="fs-5 mb-0">
            <strong>{t("laborCompany")}:</strong>{" "}
            {formatPrice(selectedWork?.companyLabel)} RON
          </p>
        </div>
      </div>

      {/* Measured Date / Order Date / Completed Date */}
      <div style={{ display: "flex", marginBottom: "0.75rem" }}>
        <div style={{ flex: 1, marginRight: "1rem" }}>
          <p className="fs-5 mb-0">
            <strong>{t("measureDate")}:</strong>{" "}
            {selectedWork?.measureDate
              ? formatDate(selectedWork.measureDate)
              : "—"}
          </p>
        </div>
        <div style={{ flex: 1 }}>
          <p className="fs-5 mb-0">
            <strong>{t("orderDate")}:</strong>{" "}
            {selectedWork?.orderDate ? formatDate(selectedWork.orderDate) : "—"}
          </p>
        </div>
      </div>
      {selectedWork?.status === "completed" && (
        <div style={{ marginBottom: "0.75rem" }}>
          <p className="fs-5 mb-0">
            <strong>{t("finishDate")}:</strong>{" "}
            {selectedWork?.finishDate
              ? formatDate(selectedWork.finishDate)
              : "—"}
          </p>
        </div>
      )}
      {selectedWork?.status === "cancelled" && (
        <div style={{ marginBottom: "0.75rem" }}>
          <p className="fs-5 mb-0">
            <strong>{t("cancelDate")}:</strong>{" "}
            {selectedWork?.cancelDate
              ? formatDate(selectedWork.cancelDate)
              : "—"}
          </p>
        </div>
      )}
    </>
  );

  return (
    <div>
      {importing && (
        <div className="import-overlay">
          <Loading />

          <div className="import-text">{t("importInProgress")}</div>
        </div>
      )}
      {/* =======================
            „Update Work” modal
        ======================= */}
      <ToastContainer
        position="top-center"
        className="p-3"
        style={{ zIndex: 2000 }}
      >
        <Toast
          bg={toast.variant}
          onClose={() => setToast((t) => ({ ...t, show: false }))}
          show={toast.show}
          delay={2000}
          autohide
        >
          <Toast.Header>
            <strong className="me-auto">{t("import")}</strong>
            <small>{t("now")}</small>
          </Toast.Header>
          <Toast.Body
            className={
              toast.variant === "warning" || toast.variant === "light"
                ? "text-dark"
                : "text-white"
            }
          >
            {toast.message}
          </Toast.Body>
        </Toast>
      </ToastContainer>

      {showAiPreview && (
        <>
          <style>{`
        .ai-preview-fullscreen .ai-sticky-header th {
          position: sticky !important;
          background: #f1f3f5 !important;
          z-index: 5;
          vertical-align: middle;
          background-clip: padding-box;
        }
        .ai-preview-fullscreen .ai-sticky-header tr:first-child th { top: 0 !important; height: 38px; }
        .ai-preview-fullscreen .ai-sticky-header tr:nth-child(2) th { top: 38px !important; height: 32px; }
        .ai-preview-fullscreen .ai-sticky-header tr:first-child th[rowspan="2"] { z-index: 7; }
        .ai-preview-fullscreen .ai-preview-table { margin-bottom: 0; height: 100%; min-height: 100%; }
        .ai-preview-fullscreen .ai-preview-table tbody tr { height: auto; }
        .ai-preview-fullscreen .ai-table-container { max-height: none; overscroll-behavior: contain; }
      `}</style>
          <div
            className="ai-preview-fullscreen"
            role="region"
            aria-label={t("aiPreviewTitle")}
            style={{
              position: "fixed",
              inset: 0,
              zIndex: 1050,
              width: "100%",
              height: "100dvh",
              display: "flex",
              flexDirection: "column",
              background: "#fff",
              overflow: "hidden"
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "12px 20px",
                borderBottom: "1px solid #dee2e6",
                flexShrink: 0
              }}
            >
              <h4 style={{ margin: 0 }}>{t("aiPreviewTitle")}</h4>
              <Button
                variant="outline-secondary"
                size="sm"
                disabled={savingImageImport}
                onClick={cancelImagePreview}
                aria-label={t("aiPreviewCancel")}
              >
                ✕
              </Button>
            </div>

            <div
              style={{
                flex: 1,
                minHeight: 0,
                overflow: "hidden",
                padding: "12px 18px"
              }}
            >
              <Row style={{ height: "100%", minHeight: 0 }} className="g-3">
                {/* IMAGE */}
                <Col xs={12} lg={4} style={{ height: "100%", minHeight: 0 }}>
                  <div
                    ref={viewerRef}
                    onWheel={handleWheel}
                    style={{
                      position: "relative",
                      height: "100%",
                      minHeight: 0,
                      touchAction: "none",
                      overflow: "hidden",
                      background: "#f5f5f5",
                      border: "1px solid #ddd",
                      cursor:
                        zoomLevel.current > 1
                          ? isDragging
                            ? "grabbing"
                            : "grab"
                          : "zoom-in"
                    }}
                    onPointerDown={handlePointerDown}
                    onPointerMove={handlePointerMove}
                    onPointerUp={handlePointerUp}
                    onPointerCancel={handlePointerUp}
                  >
                    {/* ZOOM BUTTONS */}
                    <div
                      style={{
                        position: "absolute",
                        top: 10,
                        right: 10,
                        zIndex: 10,
                        display: "flex",
                        gap: "6px"
                      }}
                    >
                      <Button
                        size="sm"
                        variant="light"
                        onClick={() => {
                          zoomImage(zoomLevel.current * 1.25);
                        }}
                      >
                        +
                      </Button>

                      <Button
                        size="sm"
                        variant="light"
                        onClick={() => {
                          zoomImage(zoomLevel.current / 1.25);
                        }}
                      >
                        -
                      </Button>
                    </div>

                    <Button
                      size="sm"
                      variant="light"
                      onClick={resetImageView}
                      style={{
                        position: "absolute",
                        right: 10,
                        bottom: 10,
                        zIndex: 10
                      }}
                      title="Kép visszaállítása"
                    >
                      1:1
                    </Button>
                    <img
                      ref={imageRef}
                      src={aiPreviewImage}
                      onLoad={resetImageView}
                      alt="ai-preview"
                      style={{
                        position: "absolute",
                        inset: 0,
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                        transformOrigin: "center center",
                        userSelect: "none",
                        pointerEvents: "none",
                        willChange: "transform"
                      }}
                      draggable={false}
                    />
                  </div>
                </Col>

                {/* TABLE */}
                <Col
                  xs={12}
                  lg={8}
                  style={{ height: "100%", minHeight: 0, overflow: "hidden" }}
                >
                  <div
                    className="ai-table-container"
                    style={{
                      width: "100%",
                      height: "100%",
                      minHeight: 0,
                      overflowY: "auto",
                      overflowX: "auto"
                    }}
                  >
                    <Table
                      bordered
                      size="sm"
                      className="ai-preview-table"
                      style={{
                        width: "100%",
                        height: "100%",
                        minHeight: "100%",
                        borderCollapse: "separate",
                        borderSpacing: 0,
                        ...(hideAiKantColumns ? { tableLayout: "fixed" } : {})
                      }}
                    >
                      <colgroup>
                        <col
                          className="col-nr"
                          style={
                            hideAiKantColumns ? { width: "4%" } : undefined
                          }
                        />
                        <col
                          className="col-culoare"
                          style={
                            hideAiKantColumns ? { width: "23%" } : undefined
                          }
                        />
                        {hideAiKantColumns && (
                          <col
                            className="col-painted"
                            style={{ width: "4.9%" }}
                          />
                        )}
                        <col
                          className="col-frezare"
                          style={
                            hideAiKantColumns ? { width: "20%" } : undefined
                          }
                        />
                        <col
                          className="col-lungime"
                          style={
                            hideAiKantColumns ? { width: "10%" } : undefined
                          }
                        />
                        <col
                          className="col-latime"
                          style={
                            hideAiKantColumns ? { width: "10%" } : undefined
                          }
                        />
                        <col
                          className="col-buc"
                          style={
                            hideAiKantColumns ? { width: "7%" } : undefined
                          }
                        />
                        {!hideAiKantColumns && <col className="col-rot" />}
                        {!hideAiKantColumns && (
                          <>
                            <col className="col-tip" />
                            <col className="col-dbc" />
                            <col className="col-tip" />
                            <col className="col-dbc" />
                          </>
                        )}
                        <col
                          className="col-obs"
                          style={
                            hideAiKantColumns ? { width: "15%" } : undefined
                          }
                        />
                        <col
                          className="col-del"
                          style={
                            hideAiKantColumns ? { width: "4%" } : undefined
                          }
                        />
                      </colgroup>
                      <thead className="ai-sticky-header">
                        <tr>
                          <th rowSpan={hideAiKantColumns ? 1 : 2}>Nr</th>
                          <th rowSpan={hideAiKantColumns ? 1 : 2}>
                            Cod culoare
                          </th>
                          {hideAiKantColumns && <th>Vopsit</th>}
                          <th rowSpan={hideAiKantColumns ? 1 : 2}>
                            Cod frezare
                          </th>
                          <th rowSpan={hideAiKantColumns ? 1 : 2}>Lungime</th>
                          <th rowSpan={hideAiKantColumns ? 1 : 2}>Lățime</th>
                          <th rowSpan={hideAiKantColumns ? 1 : 2}>Buc</th>
                          {!hideAiKantColumns && <th rowSpan={2}>Rot</th>}

                          {!hideAiKantColumns && (
                            <>
                              <th colSpan="2">Cant pe lungime</th>
                              <th colSpan="2">Cant pe lățime</th>
                            </>
                          )}
                          <th rowSpan={hideAiKantColumns ? 1 : 2}>
                            Observații
                          </th>
                          <th rowSpan={hideAiKantColumns ? 1 : 2}>Stergere</th>
                        </tr>

                        {!hideAiKantColumns && (
                          <tr>
                            <th>Tip</th>
                            <th>Buc</th>
                            <th>Tip</th>
                            <th>Buc</th>
                          </tr>
                        )}
                      </thead>
                      <tbody>
                        {aiPreviewItems.map((item, i) => {
                          if (!cellRefs.current[i]) cellRefs.current[i] = [];

                          return (
                            <tr key={i} data-row={i} className="ai-row">
                              <td>{i + 1}</td>

                              <td>
                                <AiColorPicker
                                  wide={hideAiKantColumns}
                                  colorId={item.colorId ?? null}
                                  allColors={colors}
                                  t={t}
                                  onChange={(newColorId) =>
                                    setAiPreviewItems((prev) => {
                                      const copy = [...prev];
                                      const current = copy[i];

                                      // megkeressük az új szín elérhető millingjeit
                                      const newColor = colors.find(
                                        (c) => c.colorId === newColorId
                                      );
                                      let assignedIds =
                                        newColor?.millingAssignments ?? [];
                                      if (typeof assignedIds === "string") {
                                        assignedIds = assignedIds
                                          .split(",")
                                          .map((x) => Number(x.trim()))
                                          .filter(Boolean);
                                      }

                                      // ha a jelenlegi millingId nem szerepel az új szín assignmentjei között → reset
                                      const millingStillValid =
                                        current.millingId != null &&
                                        assignedIds.includes(current.millingId);

                                      copy[i] = {
                                        ...current,
                                        colorId: newColorId,
                                        importMaterial:
                                          newColor?.materialType ||
                                          current.importMaterial,
                                        kant:
                                          String(
                                            newColor?.materialType || ""
                                          ).toUpperCase() === "MDF"
                                            ? emptyKant()
                                            : (current.kant ?? emptyKant()),
                                        millingId: millingStillValid
                                          ? current.millingId
                                          : null
                                      };
                                      return copy;
                                    })
                                  }
                                />
                              </td>

                              {hideAiKantColumns && (
                                <td>
                                  <select
                                    className="ai-input"
                                    value={item.painted ? "true" : "false"}
                                    onChange={(e) =>
                                      updateAiItem(
                                        i,
                                        "painted",
                                        e.target.value === "true"
                                      )
                                    }
                                  >
                                    <option value="true">Da</option>
                                    <option value="false">Nu</option>
                                  </select>
                                </td>
                              )}

                              <td>
                                <AiMillingPicker
                                  wide={hideAiKantColumns}
                                  millingId={item.millingId ?? null}
                                  colorId={item.colorId ?? null}
                                  allColors={colors}
                                  allMillings={millings}
                                  t={t}
                                  onChange={(newMillingId) =>
                                    setAiPreviewItems((prev) => {
                                      const copy = [...prev];
                                      copy[i] = {
                                        ...copy[i],
                                        millingId: newMillingId
                                      };
                                      return copy;
                                    })
                                  }
                                />
                              </td>

                              <td>
                                <input
                                  ref={(el) => (cellRefs.current[i][2] = el)}
                                  type="number"
                                  className="ai-input"
                                  value={item.size[0]}
                                  onKeyDown={(e) => handleCellKeyDown(e, i, 2)}
                                  onChange={(e) =>
                                    updateAiItem(i, "lun", e.target.value)
                                  }
                                />
                              </td>

                              <td>
                                <input
                                  ref={(el) => (cellRefs.current[i][3] = el)}
                                  type="number"
                                  className="ai-input"
                                  value={item.size[1]}
                                  onKeyDown={(e) => handleCellKeyDown(e, i, 3)}
                                  onChange={(e) =>
                                    updateAiItem(i, "lat", e.target.value)
                                  }
                                />
                              </td>

                              <td>
                                <input
                                  ref={(el) => (cellRefs.current[i][4] = el)}
                                  type="number"
                                  className="ai-input"
                                  value={item.qty}
                                  onKeyDown={(e) => handleCellKeyDown(e, i, 4)}
                                  onChange={(e) =>
                                    updateAiItem(i, "buc", e.target.value)
                                  }
                                />
                              </td>

                              {!hideAiKantColumns && (
                                <td>
                                  <select
                                    ref={(el) => (cellRefs.current[i][5] = el)}
                                    className="ai-input"
                                    value={item.rotable ? "true" : "false"}
                                    onKeyDown={(e) =>
                                      handleCellKeyDown(e, i, 5)
                                    }
                                    onChange={(e) =>
                                      updateAiItem(
                                        i,
                                        "rot",
                                        e.target.value === "true"
                                      )
                                    }
                                  >
                                    <option value="true">Da</option>
                                    <option value="false">Nu</option>
                                  </select>
                                </td>
                              )}

                              {!hideAiKantColumns &&
                                (isAiMdf(item) ? (
                                  <td
                                    colSpan={4}
                                    style={{
                                      textAlign: "center",
                                      color: "#999"
                                    }}
                                  >
                                    —
                                  </td>
                                ) : (
                                  <>
                                    <td>
                                      <select
                                        ref={(el) =>
                                          (cellRefs.current[i][6] = el)
                                        }
                                        className="ai-input"
                                        value={item.kant[0]}
                                        onKeyDown={(e) =>
                                          handleCellKeyDown(e, i, 6)
                                        }
                                        onChange={(e) =>
                                          updateAiItem(
                                            i,
                                            "cant_lung_type",
                                            e.target.value
                                          )
                                        }
                                      >
                                        <option value="-">-</option>
                                        <option value="04">04</option>
                                        <option value="2">2</option>
                                        <option value="1">1</option>
                                        <option value="42">42</option>
                                      </select>
                                    </td>

                                    <td>
                                      <select
                                        ref={(el) =>
                                          (cellRefs.current[i][7] = el)
                                        }
                                        className="ai-input"
                                        value={item.kant[1]}
                                        onKeyDown={(e) =>
                                          handleCellKeyDown(e, i, 7)
                                        }
                                        onChange={(e) =>
                                          updateAiItem(
                                            i,
                                            "cant_lung_count",
                                            e.target.value
                                          )
                                        }
                                      >
                                        <option value={0}>0</option>
                                        <option value={1}>1</option>
                                        <option value={2}>2</option>
                                      </select>
                                    </td>

                                    <td>
                                      <select
                                        ref={(el) =>
                                          (cellRefs.current[i][8] = el)
                                        }
                                        className="ai-input"
                                        value={item.kant[2]}
                                        onKeyDown={(e) =>
                                          handleCellKeyDown(e, i, 8)
                                        }
                                        onChange={(e) =>
                                          updateAiItem(
                                            i,
                                            "cant_lat_type",
                                            e.target.value
                                          )
                                        }
                                      >
                                        <option value="-">-</option>
                                        <option value="04">04</option>
                                        <option value="2">2</option>
                                        <option value="1">1</option>
                                        <option value="42">42</option>
                                      </select>
                                    </td>

                                    <td>
                                      <select
                                        ref={(el) =>
                                          (cellRefs.current[i][9] = el)
                                        }
                                        className="ai-input"
                                        value={item.kant[3]}
                                        onKeyDown={(e) =>
                                          handleCellKeyDown(e, i, 9)
                                        }
                                        onChange={(e) =>
                                          updateAiItem(
                                            i,
                                            "cant_lat_count",
                                            e.target.value
                                          )
                                        }
                                      >
                                        <option value={0}>0</option>
                                        <option value={1}>1</option>
                                        <option value={2}>2</option>
                                      </select>
                                    </td>
                                  </>
                                ))}

                              <td>
                                <input
                                  ref={(el) => (cellRefs.current[i][10] = el)}
                                  className="ai-input"
                                  value={item.details}
                                  onKeyDown={(e) => handleCellKeyDown(e, i, 10)}
                                  onChange={(e) =>
                                    updateAiItem(i, "obs", e.target.value)
                                  }
                                />
                              </td>

                              <td>
                                <button
                                  className="ai-delete-btn"
                                  onClick={() => removeAiItem(i)}
                                >
                                  <IonIcon
                                    icon={trashOutline}
                                    style={{ color: "red", fontSize: "1.2rem" }}
                                  />
                                </button>
                              </td>
                            </tr>
                          );
                        })}

                        <tr>
                          <td
                            colSpan={hideAiKantColumns ? 9 : 13}
                            className="ai-add-row"
                            onClick={addAiItem}
                          >
                            {t("aiPreviewAddRow")}
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </div>
                </Col>
              </Row>
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
                gap: 12,
                flexWrap: "wrap",
                padding: "12px 20px",
                borderTop: "1px solid #dee2e6",
                flexShrink: 0,
                background: "#fff"
              }}
            >
              <Form.Check
                type="checkbox"
                label="Táblagenerálás az import után (hosszabb várakozás)"
                checked={generateAfterImageImport}
                disabled={savingImageImport}
                onChange={(event) =>
                  setGenerateAfterImageImport(event.target.checked)
                }
              />
              <Button
                variant="secondary"
                disabled={savingImageImport}
                onClick={cancelImagePreview}
              >
                {t("aiPreviewCancel")}{" "}
              </Button>

              <Button
                variant="primary"
                disabled={savingImageImport}
                onClick={async () => {
                  if (imageImportSavingRef.current) return;
                  imageImportSavingRef.current = true;
                  setSavingImageImport(true);
                  let saved = false;
                  try {
                    let unresolved = 0;
                    if (savedPreview) {
                      const savedItems = await saveImagePreview({
                        items: normalizeAiMdfKant(aiPreviewItems),
                        originalIds: savedPreview.ids,
                        objectId: savedPreview.objectId,
                        workId: selectedWork.workId,
                        update: (payload) =>
                          dispatch(
                            createdItemApi.updateMultipleCreatedItemsApi(
                              payload,
                              { requiresRegenerate: false }
                            )
                          ),
                        create: (payload) =>
                          dispatch(
                            createdItemApi.createMultipleCreatedItemsApi(
                              payload,
                              { preprocess: true }
                            )
                          ),
                        remove: (ids) =>
                          dispatch(
                            createdItemApi.deleteMultipleCreatedItemsApi(ids)
                          )
                      });
                      setSavedPreview({
                        ...savedPreview,
                        ids: savedItems.map((item) => item.itemId)
                      });
                      setAiPreviewItems(
                        savedImagePreview(savedItems, savedPreview.material)
                      );
                      unresolved = savedItems.filter(
                        (item) => !item.color?.colorId
                      ).length;
                    } else {
                      unresolved = await createImportObjectAndItems({
                        items: normalizeAiMdfKant(aiPreviewItems).map((it) => ({
                          ...it,
                          importMaterial: isAiMdf(it)
                            ? "MDF"
                            : it.importMaterial || "PAL",
                          milling:
                            it.millingId != null
                              ? { millingId: it.millingId }
                              : null,
                          colorHint: it.colorHint || ""
                        })),
                        colorHint: "",
                        fileName: aiPreviewFileName
                      });
                    }

                    saved = true;
                    if (generateAfterImageImport && !unresolved) {
                      await generateAndSaveImportedWork();
                    }

                    setShowAiPreview(false);
                    zoomLevel.current = 1;
                    panRef.current = { x: 0, y: 0 };
                    panRef.current = { x: 0, y: 0 };
                    showToast(
                      `${aiPreviewItems.length} ${t("itemsImportedAi")}`,
                      "success"
                    );
                  } catch (error) {
                    if (saved) setShowAiPreview(false);
                    showToast(
                      saved
                        ? "Az elemek mentve, de a táblagenerálás sikertelen. A generálás külön újraindítható."
                        : error.message || "Az import mentése sikertelen.",
                      "danger"
                    );
                  } finally {
                    imageImportSavingRef.current = false;
                    setSavingImageImport(false);
                  }
                }}
              >
                {savedPreview ? t("save") : t("aiPreviewImport")}
              </Button>
            </div>
          </div>
        </>
      )}
      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>
            #{workId} {t("updateWork")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Row className="align-items-center">
                <Col>
                  <Form.Label className="mb-0">{t("price")}</Form.Label>
                </Col>
                <Col className="text-end">
                  <Form.Text className="text-muted mb-0">
                    {t("companyPriceHint")}{" "}
                    {selectedWork?.companyPrice != null
                      ? formatPrice(selectedWork.companyPrice)
                      : "—"}{" "}
                    RON{" "}
                  </Form.Text>
                </Col>
              </Row>
              <Form.Control
                type="number"
                value={priceInput}
                onChange={(e) => setPriceInput(+e.target.value)}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Row className="align-items-center">
                <Col>
                  <Form.Label className="mb-0">{t("clientPaid")}</Form.Label>
                </Col>
                <Col className="text-end">
                  <Form.Text className="text-muted mb-0">
                    {t("carpenterPaidHint")}{" "}
                    {selectedWork?.userPaid != null
                      ? formatPrice(selectedWork.userPaid)
                      : "—"}{" "}
                    RON{" "}
                  </Form.Text>
                </Col>
              </Row>
              <Form.Control
                type="number"
                value={paidInput}
                onChange={(e) => setPaidInput(+e.target.value)}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Row className="align-items-center">
                <Col>
                  <Form.Label className="mb-0">{t("laborCost")}</Form.Label>
                </Col>
                <Col className="text-end">
                  <Form.Text className="text-muted mb-0">
                    {t("companyLaborHint")} {selectedWork?.companyLabel ?? "—"}{" "}
                    RON{" "}
                  </Form.Text>
                </Col>
              </Row>
              <Form.Control
                type="text"
                value={labelInput}
                onChange={(e) => setLabelInput(e.target.value)}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Row className="align-items-center">
                <Col>
                  <Form.Label className="mb-0">{t("woodPrice")}</Form.Label>
                </Col>
                <Col className="text-end">
                  <Form.Text className="text-muted mb-0">
                    {t("companyMaterialHint")}{" "}
                    {selectedWork?.companyWoodPrice != null
                      ? formatPrice(selectedWork.companyWoodPrice)
                      : "—"}{" "}
                    RON{" "}
                  </Form.Text>
                </Col>
              </Row>
              <Form.Control
                type="number"
                value={woodPriceInput}
                onChange={(e) => setWoodPriceInput(+e.target.value)}
              />
            </Form.Group>

            {/* Ezek után jön a státusz‐dropdown: csak „Completed” és „Cancelled” */}
            {selectedWork?.isOrdered === true &&
            selectedWork?.companyStatus !== "Completed" ? (
              <></>
            ) : (
              <Form.Group className="mb-3">
                <Form.Label>{t("status")}</Form.Label>
                <Form.Select
                  value={statusInput}
                  onChange={(e) => setStatusInput(e.target.value)}
                >
                  {selectedWork?.status === "active" && (
                    <>
                      <option value="active">{t("active")}</option>
                      <option value="completed">{t("completed")}</option>
                    </>
                  )}
                  {selectedWork?.status === "measured" && (
                    <>
                      <option value="measured">{t("measured")}</option>
                      <option value="active">{t("active")}</option>
                      <option value="cancelled">{t("cancelled")}</option>
                    </>
                  )}
                </Form.Select>
                <Form.Text
                  className="text-muted"
                  style={{ fontSize: "0.875rem" }}
                ></Form.Text>
              </Form.Group>
            )}
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            {t("cancel")}
          </Button>
          <Button variant="primary" onClick={handleSave}>
            {t("save")}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* ==============================
            „Confirm Order” modal
        ============================== */}
      <Modal show={showConfirmModal} onHide={handleCancelOrder}>
        <Modal.Header closeButton>
          <Modal.Title>{t("confirmOrderTitle")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{t("confirmOrderBody")}</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCancelOrder}>
            {t("cancel")}
          </Button>
          <Button variant="primary" onClick={handleConfirmOrder}>
            {t("confirm")}
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={!!previewFile}
        onHide={() => {
          setPreviewFile(null);
          setPreviewUrl(null);
          setPreviewText(null);
          zoomLevel.current = 1;
          panRef.current = { x: 0, y: 0 };
        }}
        dialogClassName="resizable-modal"
        size="xl"
      >
        <Modal.Header closeButton>
          <Modal.Title>{previewFile?.name}</Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ overflow: "auto", overflowY: "auto" }}>
          {/* IMAGE */}
          {previewFile?.type === "image" && (
            <div
              ref={viewerRef}
              onWheel={handleWheel}
              style={{
                position: "relative",
                height: "65vh",
                overflow: "hidden",
                background: "#f5f5f5",
                cursor:
                  zoomLevel.current > 1
                    ? isDragging
                      ? "grabbing"
                      : "grab"
                    : "zoom-in"
              }}
              onPointerDown={handlePointerDown}
              onPointerMove={handlePointerMove}
              onPointerUp={handlePointerUp}
              onPointerCancel={handlePointerUp}
            >
              {/* zoom buttons */}
              <div
                style={{
                  position: "absolute",
                  top: 10,
                  right: 10,
                  zIndex: 10,
                  display: "flex",
                  gap: "6px"
                }}
              >
                <Button
                  size="sm"
                  variant="light"
                  onClick={() => {
                    zoomLevel.current = Math.min(zoomLevel.current + 0.2, 4);
                    updateTransform();
                  }}
                >
                  +
                </Button>

                <Button
                  size="sm"
                  variant="light"
                  onClick={() => {
                    zoomLevel.current = Math.max(zoomLevel.current - 0.2, 0.3);
                    updateTransform();
                  }}
                >
                  -
                </Button>
              </div>

              <img
                ref={imageRef}
                src={previewUrl}
                alt="preview"
                onLoad={resetImageView}
                style={{
                  position: "absolute",
                  inset: 0,
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                  transformOrigin: "center center",
                  userSelect: "none",
                  pointerEvents: "none",
                  willChange: "transform"
                }}
                draggable={false}
              />
            </div>
          )}

          {/* PDF */}
          {previewFile?.type === "pdf" && (
            <iframe
              src={previewUrl}
              title="pdf-preview"
              width="100%"
              height="600px"
            />
          )}

          {/* ===============================
          CMR PREVIEW
      =============================== */}
          {previewFile?.type === "cmr" && previewText && (
            <CmrPreview data={previewText} />
          )}

          {/* TEXT */}
          {previewFile?.type === "text" && (
            <pre style={{ whiteSpace: "pre-wrap" }}>{previewText}</pre>
          )}
          {/* EXCEL */}
          {previewFile?.type === "excel" && previewText && (
            <div style={{ overflowX: "auto" }}>
              <Table bordered size="sm">
                <tbody>
                  {previewText.map((row, rIndex) => (
                    <tr key={rIndex}>
                      {row.map((cell, cIndex) => (
                        <td key={cIndex}>{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          )}
          {/* OTHER */}
          {previewFile?.type === "other" && (
            <iframe
              src={previewUrl}
              title="file-preview"
              width="100%"
              height="600px"
            />
          )}
        </Modal.Body>
      </Modal>
      {/* ================================
            Ha még töltődik a work, mutassuk a Loading‐et
        ================================ */}
      {loading || !selectedWork ? (
        <Loading />
      ) : (
        <div
          className="work-analyzer-page"
          onDrop={handleDrop}
          onDragOver={(e) => e.preventDefault()}
        >
          {/* ======== Fejléc ======== */}
          <div className="work-header container">
            <div className="work-header-title">
              <span className="work-client-name">
                {selectedClient?.name ||
                  selectedWork.user?.name ||
                  selectedWork.user?.username}
              </span>
              <span className="work-id">#{selectedWork.workId}</span>
              <span className="work-subtitle">{t("workDetails")}</span>
            </div>

            <div className="work-header-actions">
              <Button
                variant="outline-success"
                onClick={handleExportExcel}
                disabled={exporting || createdItems.length === 0}
                title={
                  createdItems.length === 0
                    ? t("noExportItems")
                    : t("exportExcel")
                }
              >
                {exporting ? t("exportInProgress") : t("exportExcel")}
              </Button>

              <input
                ref={fileInputRef}
                type="file"
                accept=".cmr,.xml,.csv,.txt,.xlsx,.xls"
                multiple
                onChange={handleImportFile}
                style={{ display: "none" }}
              />

              {selectedWork.status !== "Completed" &&
                selectedWork.status !== "Cancelled" && (
                  <Button variant="warning" onClick={handleShowModal}>
                    {t("update")}
                  </Button>
                )}

              {!selectedWork.isOrdered && (
                <Button
                  variant="primary"
                  onClick={handleOrderSelectedWork}
                  disabled={selectedWork.isOrdered === true}
                >
                  {t("order")}
                </Button>
              )}
            </div>
          </div>

          {/* ===================================
                „Work Details” blokk – összevontan
              =================================== */}
          <div className="work-details-container container">
            <div className="work-details-card">
              {isCompanyRole ? companyAlwaysVisibleFields : alwaysVisibleFields}
              {isDetailsOpen &&
                (isCompanyRole ? companyExpandedFields : expandedFields)}
              <div
                className="work-details-toggle"
                onClick={() => setIsDetailsOpen((prev) => !prev)}
              >
                {isDetailsOpen ? t("showLess") : t("showMore")}
              </div>
            </div>
          </div>

          <div className="work-content container">
            <Row className="work-content-row">
              {/* MATERIALS */}
              <Col xs={12} lg={6} className="work-panel-col">
                <div className="work-panel-card">
                  <div className="card-body">
                    <p className="work-panel-title">
                      {t("materials")} -{" "}
                      <span className="fs-5 fw-normal text-start">
                        {t("totalWoodPrice")}: {formatPrice(totalWoodPrice)} RON
                      </span>
                    </p>
                    <WorkMaterialsTable groups={sortedGroupedTables} t={t} />
                  </div>
                </div>
              </Col>

              {/* FILE LIST */}
              <Col xs={12} lg={6} className="work-panel-col">
                <div className="work-panel-card">
                  <div className="card-body">
                    <div className="work-files-header">
                      <span className="fs-4 fw-semibold work-panel-title">
                        {t("files")}
                      </span>{" "}
                      <Button
                        variant="outline-secondary"
                        size="sm"
                        disabled={uploadingFiles}
                        className="upload-btn"
                        onClick={() => fileUploadRef.current?.click()}
                      >
                        {uploadingFiles
                          ? t("uploading")
                          : t("uploadFiles")}{" "}
                      </Button>
                      <input
                        type="file"
                        multiple
                        hidden
                        ref={fileUploadRef}
                        onChange={handleFileInputChange}
                      />
                    </div>

                    <WorkFilesTable
                      files={workFiles}
                      t={t}
                      formatFileSize={formatFileSize}
                      isImageFile={isImageFile}
                      onPreview={handlePreviewFile}
                      onDownload={handleDownloadFile}
                      onImport={handleImportExistingFile}
                      onManualImport={handleManualImport}
                      onDelete={handleDeleteFile}
                    />
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      )}
    </div>
  );
}

export default WorkAnalyzer;
